<!-- eslint-disable vue/v-on-event-hyphenation -->
<template>
  <div class="category-details">
    <CategoryDetailsTagSelector
      v-if="!shouldHideOverviewForCategory"
      :selectedTab="selectedTab"
      :shouldHideOverviewForCategory="shouldHideOverviewForCategory"
      @tabSelected="setSelectedTab"
    />
    <div
      v-if="selectedTab === 'overall' && category && category.name !== null"
      class="row"
    >
      <CategoryDetailsOverview
        v-if="shouldShowCategoryDetailsOverview"
        :category="category"
        :shouldShowResultsPerPerson="shouldShowResultsPerPerson"
        :resultsPerPerson="resultsPerPerson"
        :userIsAdminForCurrentGroupOrSuperAdmin="
          userIsAdminForCurrentGroupOrSuperAdmin
        "
        :theme="theme"
      />
      <CategoryDetailsInfoTexts
        :currentCategoryHasAtLeastOneZeroToTenQuestion="
          currentCategoryHasAtLeastOneZeroToTenQuestion
        "
        :category="category"
      />
    </div>

    <div v-if="selectedTab === 'questions'" class="row">
      <CategoryDetailsQuestions
        :id="id"
        :isIndividualGroup="isIndividualGroup"
        :category="category"
        :requestHeightCalculation="onSelectCategoryTab"
        :loadQuestionResponses="loadQuestionResponses"
        :updateFollowupQuestionStateForQuestion="
          updateFollowupQuestionStateForQuestion
        "
        :followUpQuestionsState="followUpQuestionsState"
        :userIsMemberOfSelectedGroup="userIsMemberOfSelectedGroup"
        :loadingQuestionResponses="loadingQuestionResponses"
      />
    </div>
  </div>
</template>

<script>
import CategoryDetailsOverview from './CategoryDetailsOverview.vue'
import CategoryDetailsQuestions from './CategoryDetailsQuestions.vue'
import CategoryDetailsInfoTexts from './CategoryDetailsInfoTexts.vue'
import CategoryDetailsTagSelector from './CategoryDetailsTagSelector.vue'

export default {
  name: 'CategoryDetails',
  components: {
    CategoryDetailsOverview,
    CategoryDetailsQuestions,
    CategoryDetailsInfoTexts,
    CategoryDetailsTagSelector
  },
  props: {
    category: {
      type: Object,
      default: () => {}
    },
    // currentCategoryHasAtLeastOneZeroToTenQuestion: {
    //   type: Boolean,
    //   default: false
    // },
    id: {
      type: String,
      default: ''
    },
    followUpQuestionsState: {
      type: Object,
      default: () => {}
    },
    isIndividualGroup: {
      type: Boolean,
      default: false
    },
    updateFollowupQuestionStateForQuestion: {
      type: Function,
      default: () => {}
    },
    loadQuestionResponses: {
      type: Function,
      default: () => {}
    },
    resultsPerPerson: {
      type: [Object, Boolean],
      default: false
    },
    selectedTab: {
      type: String,
      default: 'overall'
    },
    shouldHideOverviewForCategory: {
      type: Boolean,
      default: false
    },
    shouldShowResultsPerPerson: {
      type: Boolean,
      default: false
    },
    surveyName: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'default'
    },
    onSelectCategoryTab: {
      type: Function,
      default: () => {}
    },
    userIsAdminForCurrentGroupOrSuperAdmin: {
      type: Boolean,
      default: false
    },
    singleStatItem: {
      type: Object,
      default: () => {}
    },
    userInfo: {
      type: Object,
      default: () => {}
    },
    selectedGroup: {
      type: Object,
      default: () => {}
    },
    loadingQuestionResponses: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    currentCategoryHasAtLeastOneZeroToTenQuestion() {
      return Object.keys(this.category?.questions || {})?.some(
        (questionName) =>
          this.category.questions[questionName].type === 'zeroToTen'
      )
    },
    shouldShowCategoryDetailsOverview() {
      return (
        (this.shouldShowResultsPerPerson ||
          this.currentCategoryHasAtLeastOneZeroToTenQuestion) &&
        this.surveyName &&
        this.category
      )
    },
    userIsMemberOfSelectedGroup() {
      return (
        this.userInfo.groups.includes(this.selectedGroup.name) ||
        this.selectedGroup.name === this.userInfo.organizationName
      )
    }
  },
  methods: {
    setSelectedTab(tabName) {
      this.onSelectCategoryTab(tabName)
    }
  }
}
</script>
